<template>
  <div>
    <section class="container">
      <ul v-if="details != ''">
        <li class="disBlock">
          <h3>{{ details.name }}</h3>
        </li>
        <li class="disBlock">
          <label>手机号：</label>
          <p>{{ details.phone }}</p>
        </li>
        <!-- <li class="disBlock">
          <label>身份证号：</label>
          <p>{{ details.id_card }}</p>
        </li> -->
        <li class="disBlock">
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li class="disBlock">
          <label>日期：</label>
          <p>{{ details.month_date }}</p>
        </li>
        <li>
          <label>工资基数：</label>
          <p>{{ Number(details.base_salary) + "元" }}</p>
        </li>
        <li>
          <label>长期工考勤工资合计：</label>
          <p>{{ Number(details.work_salary) + "元" }}</p>
        </li>
        <li>
          <label>绩效工资：</label>
          <p>{{ Number(details.merits_salary) + "元" }}</p>
        </li>
        <li>
          <label>津贴合计：</label>
          <p>{{ Number(details.subsidy_salary) + "元" }}</p>
        </li>
        <li>
          <label>计件提成：</label>
          <p>{{ Number(details.count_salary) + "元" }}</p>
        </li>
        <li>
          <label>支援补贴：</label>
          <p>{{ Number(details.help_salary) + "元" }}</p>
        </li>
        <li>
          <label>内推奖励：</label>
          <p>{{ Number(details.inner_help_salary) + "元" }}</p>
        </li>
        <li>
          <label>店员拉新：</label>
          <p>{{ Number(details.new_salary) + "元" }}</p>
        </li>
        <li>
          <label>扣款合计：</label>
          <p>{{ Number(details.withhold_salary) + "元" }}</p>
        </li>
        <li>
          <label>福利天数：</label>
          <p>{{ Number(details.welfare_day) + "天" }}</p>
        </li>
        <li>
          <label>福利工资：</label>
          <p>{{ Number(details.welfare_salary) + "元" }}</p>
        </li>
        <li>
          <label>保险：</label>
          <p>{{ Number(details.insurance) + "元" }}</p>
        </li>
        <li>
          <label>系统预支：</label>
          <p>{{ Number(details.pre_amount) + "元" }}</p>
        </li>
        <li>
          <label>线下预支：</label>
          <p>{{ Number(details.pre_in) + "元" }}</p>
        </li>
        <li>
          <label>应发：</label>
          <p>{{ Number(details.pre_provide) + "元" }}</p>
        </li>
        <li>
          <label>实发：</label>
          <p>{{ Number(details.provide) + "元" }}</p>
        </li>
        <li
          v-show="details.float_data_config != ''"
          v-for="(item, k) in details.float_data_config"
          :key="k"
        >
          <label>{{ item.name + "：" }}</label>
          <p>{{ item.value }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.details = this.detailsVal;
    }
    // console.log(this.detailsVal);
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.details = this.detailsVal;
      // console.log(this.detailsVal);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 10px;
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .disBlock {
      display: block;
    }
  }
}
</style>
